import { useEffect, useRef, useState } from "react";

export const DebouncedInput = ({
    type,
    name,
    onChange,
    wait,
    onDebounced,
    controlledValue,
    placeholder,
    className
}: {
    type: string;
    name: string;
    onChange: (value: string) => void;
    wait: number;
    onDebounced?: () => void;
    controlledValue?: string;
    placeholder?: string;
    className?: string;
}) => {
    // State
    const [timerId, setTimerId] = useState<NodeJS.Timeout | null>(null);
    const [value, setValue] = useState(controlledValue);

    // Refs
    const inputRef = useRef<HTMLInputElement | null>(null);

    // Handlers
    // Debounce function
    const debounce = (callback: () => void) => {
        if (timerId) {
            clearTimeout(timerId);
        }

        const untrackedTimer = setTimeout(() => {
            callback();
        }, wait);
        setTimerId(untrackedTimer);
    }
    // Debounce trigger
    const debouncedOnChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        setValue(event.target.value);
        onDebounced && onDebounced();
        debounce(() => { onChange(event.target.value) });
    }

    // On changes
    useEffect(() => {
        if (!!controlledValue && !!inputRef.current && controlledValue !== value) {
            // Change while ignoring debounce
            inputRef.current.value = controlledValue;
        }
    }, [controlledValue]);

    return <input ref={inputRef} name={name} className={className} type={type} placeholder={placeholder} onChange={debouncedOnChange} />;
}